import type { ICandidate } from "@bbj-types/candidate";
import { useCallback } from "react";
import { axiosWithoutInterceptors } from "./axios";

export type ICreateCandidateFromPrescriberBody = Pick<
  ICandidate,
  "gender" | "firstName" | "lastName" | "address" | "mail" | "phone" | "additionalSections" | "secuNumber" | "cafNumber"
> &
  Required<Pick<ICandidate, "organisation">>;

export const useCreateCandidateFromPrescriber = () => {
  const [state, execute, cancel] = axiosWithoutInterceptors<void, ICreateCandidateFromPrescriberBody, unknown>(
    {
      url: "/prescriber",
      method: "POST",
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ICreateCandidateFromPrescriberBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
